import apiClient from '../services/apiClient'

export const getAllCoachs = async () => {
    return (await apiClient.get('/coachs')).data
}

export const resetPassword = async (email: string) => {
    return await apiClient.post('/coachs/reset-password', { email })
}
